module.exports = __webpack_public_path__ + "static/risotto_1-13865d64d8de9361539d7c2ace48fd76.png";